import React from 'react';
import ReactPlaidLink from './ReactPlaidLink';

class PlaidBaseComponent extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      disabled: false,
    };
  }

  onSubmitClick = (event) => {
    event.preventDefault();
    if (this.props.onSubmitClick) {
      this.props.onSubmitClick.call(this, event);
    }
  };

  afterPlaidClickHandled = () => {
    this.setState({
      disabled: true,
    });
  };

  onSuccess = (publicToken, metadata) => {
    if (this.props.onSuccess) {
      this.props.onSuccess(publicToken, metadata);
    }
  };

  onExit = () => {
    if (this.props.onExit) {
      this.props.onExit.call(this);
    }
    this.setState({
      disabled: false,
    });
    window.analytics.track('Closed Plaid Modal', {});
  };

  renderChildren = () => React.Children.map(this.props.children, child => React.cloneElement(child, {
    onClick: this.onSubmitClick,
    ref: 'plaidSubmitElement',
    disabled: this.state.disabled,
  }));

  render () {
    return (
      <span className="PlaidBaseComponent">
        <div className={this.props.layoutClasses}>
          <ReactPlaidLink
            afterPlaidClickHandled={this.props.afterPlaidClickHandled || this.afterPlaidClickHandled}
            checkForExistingMembership={this.props.checkForExistingMembership}
            clientName="charity: water"
            onExit={this.onExit}
            onSuccess={this.onSuccess}
            plaidEnv={this.props.plaidEnv}
            plaidKey={this.props.plaidKey}
            product="auth"
            selectAccount={true}
          >
            {this.renderChildren()}
          </ReactPlaidLink>
        </div>
      </span>
    );
  }
}

export default PlaidBaseComponent;
